export interface OperatorConfigurations {
  isStoreLogin: boolean
}

export const defaultOperatorConfig: OperatorConfigurations = {
  isStoreLogin: false,
}
